import {
  INTERVAL_SIZE, PITCH_INDEX, KEY_LIST, DEGREE_NAMES
} from '@/utils/musical_constants'

export function getPitchNumber (noteString) {
  const pitchRegex = /(?<name>[A-G](b{1,2}|x|#|\*|n)?)(?<octave>\d*)/
  const match = noteString.match(pitchRegex)
  if (!match) {
    console.warn(`Invalid note name '${noteString}'`)
    return null
  }
  const octave = parseInt(match.groups.octave) || 5
  const i = PITCH_INDEX[match.groups.name]
  return (octave + 1) * 12 + i
}

export function getPitchName (pitch, {
  specifiedLetter = null,
  withOctave = false
} = {}) {
  const p = pitch % 12
  // const accidentalNumber = getAccidentalNumber(keyIndex)
  // const offset = 0

  // Find a name with specified letter
  if (specifiedLetter && 'ABCDEFG'.includes(specifiedLetter)) {
    const candidates = Object.keys(PITCH_INDEX)
      .filter(c => c.startsWith(specifiedLetter) && (12 + PITCH_INDEX[c]) % 12 === p)
    if (!candidates.length) { // Enharmonic substitution
      return getPitchName(pitch, { withOctave: withOctave })
    }
    const letter = candidates[0]
    let octave = ''
    if (withOctave) {
      octave = getPitchOctaveNumber(pitch)
      if (PITCH_INDEX[letter] > 11) {
        octave--
      }
      if (PITCH_INDEX[letter] < 0) {
        octave++
      }
    }
    return letter + octave.toString()
  } else {
    const letter = DEGREE_NAMES[0][p]
    if (withOctave) {
      return letter + getPitchOctaveNumber(pitch)
    }
    return letter
  }
}

export function addIntervalToNoteName (name, interval) {
  if (typeof INTERVAL_SIZE[interval] === 'undefined') {
    console.error('Invalid interval', interval)
  }
  const pitch = getPitchNumber(name)
  const letter = name[0]
  const octave = name.replaceAll(/\D+/g, '')
  const newPitch = pitch + INTERVAL_SIZE[interval]
  const letterShift = parseInt(interval.substring(1)) - 1
  const newLetter = 'ABCDEFG'[('ABCDEFG'.search(letter) + letterShift) % 7]
  return getPitchName(newPitch, {
    withOctave: !!octave,
    specifiedLetter: newLetter
  })
}

export function getPitchOctaveNumber (pitch) {
  return Math.floor(pitch / 12) - 1
}

export function getKeyName (numberOfAccidentals, sharp = false) {
  if (numberOfAccidentals === 0) {
    return 'C'
  } else {
    return KEY_LIST[sharp ? 0 : 1][numberOfAccidentals - 1]
  }
}

export function getAccidentalNumber (keyName) {
  for (const i of [0, 1]) {
    const index = KEY_LIST[i].findIndex(k => k === keyName)
    if (index > -1) {
      return index + 1
    }
  }
  return 0
}

export function getInterval (p1, p2) {
  if (p1 <= p2) {
    p2 -= Math.floor((p2 - p1) / 12) * 12
  } else {
    p2 += Math.floor((p1 - p2) / 12) * 12 + 12
  }
  return (p2 - p1) % 12
}
